<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1>Contents</h1>
<p class="noindentno" id="introduction"><a href="#/005introduction">Introduction</a></p>
<p class="noindentno" id="p1"><a href="#/006part1">The Methods</a></p>
<blockquote>
<p class="noindent" id="ch1"><a href="#/007chapter1">Basic Cake Balls</a></p>
<p class="noindent" id="ch2"><a href="#/008chapter2">Basic Cake Pops</a></p>
<p class="noindent" id="ch3"><a href="#/009chapter3">Basic Cupcake Pops</a></p>
<p class="noindent" id="ch4"><a href="#/010chapter4">Basic Cupcake Bites</a></p>
<p class="noindent" id="ch5"><a href="#/011chapter5">Troubleshooting</a></p>
</blockquote>
<p class="noindentno" id="p2"><a href="#/012part2">The Techniques</a></p>
<blockquote>
<p class="noindent" id="ch6"><a href="#/013chapter6">Cake Pop Flavor Combinations</a></p>
<p class="noindent" id="ch7"><a href="#/014chapter7">Crumbling Your Cake</a></p>
<p class="noindent" id="ch8"><a href="#/015chapter8">Creating Shapes</a></p>
<p class="noindent" id="ch9"><a href="#/016chapter9">Candy Coating Basics</a></p>
<p class="noindent" id="ch10"><a href="#/017chapter10">Dipping Methods</a></p>
<p class="noindent" id="ch11"><a href="#/018chapter11">My Two Favorite Tools</a></p>
<p class="noindent" id="ch12"><a href="#/019chapter12">Main Ingredients</a></p>
<p class="noindent" id="ch13"><a href="#/020chapter13">Equipment</a></p>
<p class="noindent" id="ch14"><a href="#/021chapter14">Sprinkles</a></p>
<p class="noindent" id="ch15"><a href="#/022chapter15">Decorative Add-Ons</a></p>
</blockquote>
<p class="noindentno" id="p3"><a href="#/023part3">Cake Pop projects</a></p>
<blockquote>
<p class="noindent" id="ch16"><a href="#/024chapter16">Sweet Hearts</a></p>
<p class="noindent" id="ch17"><a href="#/025chapter17">Spring Fling</a></p>
<p class="noindent" id="ch18"><a href="#/026chapter18">Spring Chicks</a></p>
<p class="noindent" id="ch19"><a href="#/027chapter19">Pastel Bunny Pops</a></p>
<p class="noindent" id="ch20"><a href="#/028chapter20">Sugar Sheep</a></p>
<p class="noindent" id="ch21"><a href="#/029chapter21">Confetti Easter Eggs</a></p>
<p class="noindent" id="ch22"><a href="#/030chapter22">Easter Baskets</a></p>
<p class="noindent" id="ch23"><a href="#/031chapter23">Clowning Around</a></p>
<p class="noindent" id="ch24"><a href="#/032chapter24">Ice Cream Cone Sundaes</a></p>
<p class="noindent" id="ch25"><a href="#/033chapter25">Chocolate Cupcake Pops</a></p>
<p class="noindent" id="ch26"><a href="#/034chapter26">Popcorn Bags</a></p>
<p class="noindent" id="ch27"><a href="#/035chapter27">Apple Pops</a></p>
<p class="noindent" id="ch28"><a href="#/036chapter28">Strawberry Patch Pops</a></p>
<p class="noindent" id="ch29"><a href="#/037chapter29">Bride &amp; Groom Cake Pops</a></p>
<p class="noindent" id="ch30"><a href="#/038chapter30">Baby Faces</a></p>
<p class="noindent" id="ch31"><a href="#/039chapter31">Graduation Caps</a></p>
<p class="noindent" id="ch32"><a href="#/040chapter32">Pool Party Pops</a></p>
<p class="noindent" id="ch33"><a href="#/041chapter33">Martians</a></p>
<p class="noindent" id="ch34"><a href="#/042chapter34">Robots</a></p>
<p class="noindent" id="ch35"><a href="#/043chapter35">Monster Pops</a></p>
<p class="noindent" id="ch36"><a href="#/044chapter36">Pirate Pops</a></p>
<p class="noindent" id="ch37"><a href="#/045chapter37">Game Ball Cupcake Bites</a></p>
<p class="noindent" id="ch38"><a href="#/046chapter38">Lovely Little Ladybugs</a></p>
<p class="noindent" id="ch39"><a href="#/047chapter39">Froggies</a></p>
<p class="noindent" id="ch40"><a href="#/048chapter40">Barnyard Friends</a></p>
<p class="noindent" id="ch41"><a href="#/049chapter41">Puppy Pops</a></p>
<p class="noindent" id="ch42"><a href="#/050chapter42">Lions, Tigers &amp; Bears, Oh My!</a></p>
<p class="noindent" id="ch43"><a href="#/051chapter43">Koala Bears</a></p>
<p class="noindent" id="ch44"><a href="#/052chapter44">Panda Bears</a></p>
<p class="noindent" id="ch45"><a href="#/053chapter45">Monkey Business</a></p>
<p class="noindent" id="ch46"><a href="#/054chapter46">Black Cats</a></p>
<p class="noindent" id="ch47"><a href="#/055chapter47">Jack-o’-Lanterns</a></p>
<p class="noindent" id="ch48"><a href="#/056chapter48">Ghostly Goodies</a></p>
<p class="noindent" id="ch49"><a href="#/057chapter49">Spooky Witches</a></p>
<p class="noindent" id="ch50"><a href="#/058chapter50">Yummy Mummies</a></p>
<p class="noindent" id="ch51"><a href="#/059chapter51">Owls</a></p>
<p class="noindent" id="ch52"><a href="#/060chapter52">Turkey Time</a></p>
<p class="noindent" id="ch53"><a href="#/061chapter53">Hanukkah Pops</a></p>
<p class="noindent" id="ch54"><a href="#/062chapter54">Reindeer</a></p>
<p class="noindent" id="ch55"><a href="#/063chapter55">Simple Santa Hats</a></p>
<p class="noindent" id="ch56"><a href="#/064chapter56">Cheery Christmas Trees</a></p>
<p class="noindent" id="ch57"><a href="#/065chapter57">Sweet Snowmen</a></p>
</blockquote>
<p class="noindentno" id="p4"><a href="#/066part4">Cake &amp; Frosting recipes</a></p>
<blockquote><p class="noindent" id="ch58"><a href="#/067chapter58">Cake Recipes</a></p>
<p class="noindent" id="ch59"><a href="#/068chapter59">Frosting Recipes</a></p>
</blockquote>
<p class="noindentno" id="p5"><a href="#/069part5">Displaying, Storing Shipping &amp; Supplies</a></p>
<blockquote>
<p class="noindent"><a href="#/069part5#page_152">Displaying Your Cake Pops</a></p>
<p class="noindent"><a href="#/069part5#page_154">Storing and Shipping Cake Pops</a></p>
<p class="noindent" id="ch60"><a href="#/070chapter60">Supplies</a></p></blockquote>
<p class="noindentno" id="tableofequivalents"><a href="#/073tableofequivalents">Table of Equivalents</a></p>
<div id="fbmatter">
<p class="noindentno" id="dedication"><a href="#/003dedication">Dedication</a></p>
<p class="noindentno" id="acknowledgments"><a href="#/074acknowledgments">Acknowledgments</a></p>
<p class="noindentno" id="ch61"><a href="#/071chapter61">Cake Pop Projects Photo Index</a></p>
<p class="noindentno" id="index"><a href="#/072index">Index</a></p>
<p class="noindentno" id="copyright"><a href="#/075copyright">Copyright</a></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-toc.vue?270f2420